import type { StateCreator } from 'zustand';

import type { CompassSlice, GlobalStore } from '../schema';

export const createCompassSlice: StateCreator<
  GlobalStore,
  [['zustand/devtools', never]],
  [],
  CompassSlice
> = (set) => ({
  compassIsLoading: false,
  compassIsFetched: false,
  compassJsonData: null,
  setCompassState: (updates) => set(updates as Partial<GlobalStore>, false, 'compass/set'),
});
